// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__+X3X4","fadeIn":"ScrollToTop_fadeIn__czKZr"};